import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";
import { TipoDTO } from "app/main/apps/shared/interfaces/tipo.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { ValidadoresFormularioService } from "app/main/apps/shared/services/util/validadores-formulario.service";

@Component({
    selector: "app-dialog-contratista",
    templateUrl: "./dialog-contratista.component.html",
    styleUrls: ["./dialog-contratista.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class DialogContratistaComponent implements OnInit {
    @Input() bancos: any[] = [];
    @Input() tiposCuenta: any[] = [];
    formContratista: FormGroup;
    constructor(
        public dialogRef: MatDialogRef<DialogContratistaComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            contratista: ContratistaDTO;
            editar: boolean;
            bancos: CodigoDTO[];
            tiposCuenta: TipoDTO[];
        },
        private fb: FormBuilder,
        private _validadoresFormSrvc: ValidadoresFormularioService
    ) {}

    ngOnInit(): void {
        //console.log(this.data.bancos);
        this.initForm();
    }

    initForm() {
        this.formContratista = this.fb.group({
            rut: [
                {
                    value: this.data?.contratista?.rut || null,
                    disabled: this.data.editar,
                },
                {
                    validators: [
                        Validators.required,
                        this._validadoresFormSrvc.validadorRut(),
                    ],
                },
            ],
            nombres: [
                this.data?.contratista?.nombres || null,
                {
                    validators: [Validators.required, Validators.minLength(3), Validators.maxLength(100)],
                },
            ],
            apellidos: [
                this.data?.contratista?.apellidos || null,
                {
                    validators: [Validators.required, Validators.minLength(3), Validators.maxLength(100)],
                },
            ],
            banco: [
                this.data?.contratista?.banco?.id || null,
                {
                    validators: [Validators.required],
                },
            ],
            tipoCuenta: [
                this.data?.contratista?.tipoCuenta?.id || null,
                {
                    validators: [Validators.required],
                },
            ],
            nroCuenta: [
                this.data?.contratista?.numeroCuenta || null,
                {
                    validators: [Validators.required, Validators.minLength(3), Validators.maxLength(20)],
                },
            ],

            correo: [
                this.data?.contratista?.email || null,
                { validators: [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")] },
            ],

        });
    }

    get rut() {
        return this.formContratista.get("rut");
    }
    get nombres() {
        return this.formContratista.get("nombres");
    }
    get apellidos() {
        return this.formContratista.get("apellidos");
    }
    get banco() {
        return this.formContratista.get("banco");
    }
    get tipoCuenta() {
        return this.formContratista.get("tipoCuenta");
    }
    get nroCuenta() {
        return this.formContratista.get("nroCuenta");
    }
    get correo() {
        return this.formContratista.get("correo");
    }
}
